import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function MelhoresCategoriasPage() {
  return <BlogArticleLayout slug="melhores-categorias-hoobuy-2026" />;
}